import { schema } from 'normalizr'

export default new schema.Entity(
    'devicesSummary',
    {},
    {
        idAttribute: 'deviceId',
        processStrategy: summary => ({
            // Meta
            _type: 'deviceSummary',
            // Fields
            ...summary,
            distance: Math.abs(summary.distance),
        }),
    }
)
